import PropTypes from "prop-types";
import { createElement, forwardRef } from "react";

function preventDefault(event) {
  event.preventDefault();
}

export const Form = forwardRef(function(
  {
    action,
    acceptCharset,
    autoComplete,
    children,
    className,
    encType,
    id,
    method,
    // name, // deprecated
    noValidate,
    onSubmit = preventDefault,
    rel,
    target,
  },
  ref
) {
  return createElement(
    "form",
    {
      action,
      acceptCharset,
      autoComplete,
      className,
      encType,
      id,
      method,
      // name,
      noValidate,
      onSubmit,
      ref,
      rel,
      target,
    },
    children
  );
});

Form.propTypes = {
  action: PropTypes.string,
  acceptCharset: PropTypes.string,
  autoComplete: PropTypes.oneOf(["off", "on"]),
  children: PropTypes.node,
  className: PropTypes.string,
  encType: PropTypes.oneOf([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain",
  ]),
  id: PropTypes.string,
  method: PropTypes.oneOf(["post", "get", "dialog"]),
  // name: PropTypes.string, // deprecated
  noValidate: PropTypes.bool,
  onSubmit: PropTypes.func,
  rel: PropTypes.string,
  target: PropTypes.oneOf(["_self", "_blank", "_parent", "_top"]),
};
